import { FormGroup, Checkbox, Switch } from "@blueprintjs/core";
import {
  SingleCheckboxProps,
  SingleCheckboxFieldValue,
  FieldLabeledProps,
} from "../../types/fieldTypes";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { useSingleCheckboxField } from "./useSingleCheckboxField";
import classNames from "classnames";

/** Base SingleCheckboxField Props*/
export interface SingleCheckboxFieldProps extends SingleCheckboxProps {
  labelProps?: FieldLabeledProps;
  displayAsSwitch?: boolean;
  disableOptimisticUpdate?: boolean;
}

const SingleCheckboxField: React.FC<SingleCheckboxFieldProps> = (props) => {
  const { localValues, setLocalValues } = useSingleCheckboxField(props);

  const checkboxFieldProps = {
    label: props.text,
    disabled: props.disabled,
    checked: localValues,
    onChange: () => {
      let newLocalValues: SingleCheckboxFieldValue;
      if (localValues) {
        newLocalValues = false;
      } else {
        newLocalValues = true;
      }
      if (!props.disableOptimisticUpdate) {
        setLocalValues(newLocalValues);
      }
      props.onSubmit && props.onSubmit(newLocalValues);
    },
  };

  return (
    <div className="ucl-base-input-checkbox-field-container">
      <FormGroup
        className={classNames(
          "base-field checkbox-field single-checkbox-field",
          {
            "has-required-background": props.isRequired && localValues !== true,
          },
          {
            "label-on-top": props.labelProps?.labelOnTop,
          },
          { "label-regular": !props.labelProps?.labelOnTop }
        )}
      >
        {props.label && (
          <FieldLabel
            labelName={props.label}
            tooltipDescription={props.description}
            fieldProps={{ ...props, value: localValues }}
            isRequired={props.isRequired}
            {...props.labelProps}
          />
        )}
        {props.displayAsSwitch ? (
          <Switch {...checkboxFieldProps} />
        ) : (
          <Checkbox {...checkboxFieldProps} />
        )}
        {props.errorMessages && (
          <FormFieldErrorContainer errorMessages={props.errorMessages} />
        )}
      </FormGroup>
    </div>
  );
};

export default SingleCheckboxField;
